import { render, staticRenderFns } from "./G_140_HaisoIrai_ChildHeader.vue?vue&type=template&id=789de9db&scoped=true&"
import script from "./G_140_HaisoIrai_ChildHeader.vue?vue&type=script&lang=ts&"
export * from "./G_140_HaisoIrai_ChildHeader.vue?vue&type=script&lang=ts&"
import style0 from "./G_140_HaisoIrai_ChildHeader.vue?vue&type=style&index=0&id=789de9db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789de9db",
  null
  
)

export default component.exports